export const IMAGE_BASE_URL = 'https://images.autone.io';
